import { createSchema, morphism } from 'morphism';

const merchantSchema = createSchema(
  {
    id: '_id',
    createdAt: 'createdAt',
    deleted: 'deleted',
    code: 'code',
    name: 'name',
    organizationCode: 'organizationCode',
    updatedAt: 'updatedAt',
    status: 'status',
    configs: 'configs',
    meta: 'meta'
  },
  { undefinedValues: { strip: true } }
);

export default {
  merchant: createSchema(merchantSchema, { undefinedValues: { strip: true } }),
  merchantList: createSchema(
    {
      docs: source => morphism(merchantSchema, source.docs),
      pagination: {
        limit: 'limit',
        page: 'page',
        pages: 'totalPages',
        total: 'totalDocs'
      }
    },
    { undefinedValues: { strip: true } }
  )
};
